<template>
  <div>
     
    <v-container grid-list-md>

      <div class="pt-8 pb-4">
        <span class="display-1">My profile</span>
      </div>
    
      <v-layout column>
        <v-card>
          <v-card-text>
            Nothing here yet!
          </v-card-text>
        </v-card>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
}
</script>
